import { render, staticRenderFns } from "./custom-pagination.vue?vue&type=template&id=11663c55"
import script from "./custom-pagination.vue?vue&type=script&lang=js"
export * from "./custom-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports